import { VehicleValuationType } from "@/api-schema-enums";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

const VEHICLE_VALUATION_TYPE_OPTIONS: { id: VehicleValuationType; name: string }[] = [
  { id: VehicleValuationType.Default, name: "fab:VehicleValuationTypeDefault" },
  { id: VehicleValuationType.LeasingBuyout, name: "fab:VehicleValuationTypeLeasingBuyout" },
  { id: VehicleValuationType.WholesaleBuyer, name: "fab:VehicleValuationTypeWholesaleBuyer" },
];

export class VehicleValuationTypeFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id: string = "valuationType";
  readonly labelSingular = "fab:VehicleValuationType";
  readonly labelPlural = "fab:VehicleValuationType";
  readonly placeholder = "fab:SelectValuationType";
  readonly searchPlaceholder = "fab:SearchValuationType";
  readonly emptyText = "fab:NoValuationTypeFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: VEHICLE_VALUATION_TYPE_OPTIONS,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
